// CSS Preloader utility to prevent FOUC (Flash of Unstyled Content)
export const preloadCSS = (cssPath) => {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssPath;
    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`Failed to load CSS: ${cssPath}`));
    document.head.appendChild(link);
  });
};

// Preload multiple CSS files
export const preloadMultipleCSS = async (cssPaths) => {
  try {
    await Promise.all(cssPaths.map(preloadCSS));
  } catch (error) {
    console.warn('Some CSS files failed to preload:', error);
  }
};

// Critical CSS paths for immediate loading
export const criticalCSSPaths = [
  './src/components/Layout/Layout.scss',
  './src/components/Sidenav/Sidenave.scss',
  './src/components/Loading/Loading.scss',
  './src/components/Notfound/Notfound.scss',
  './src/pages/Auth/Login.scss'
];

// Preload critical CSS on app initialization
export const initializeCriticalCSS = () => {
  if (typeof window !== 'undefined') {
    preloadMultipleCSS(criticalCSSPaths);
  }
};
